import { Box } from '@material-ui/core';
import { BorrowerDocumentationRequired, Loan } from '@nemuru-eng/js-api-client';

import { ActionsButtons } from '@/components/modules/DocumentsValidation/components/_shared/ActionsButtons/ActionsButtons';
import { DocumentationStepTracker } from '@/components/modules/DocumentsValidation/components/_shared/DocumentationStepTracker';
import { DocumentsValidationSteps } from '@/components/modules/DocumentsValidation/components/steps/DocumentsValidationSteps';
import { useDocumentsValidationContext } from '@/components/modules/DocumentsValidation/contexts/DocumentsValidationContext';
import { useValidationSteps } from '@/components/modules/DocumentsValidation/hooks/useValidationSteps';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { DISABLED_STATUSES } from '@/config/loanConfig';
import { PendingDataType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

interface DocumentsValidationProcessProps {
  revalidateValues: () => Promise<{ loan: Loan; documentation: BorrowerDocumentationRequired }>;
}

export const DocumentsValidationProcess = ({ revalidateValues }: DocumentsValidationProcessProps) => {
  const { md } = useScreen();
  const { loan } = useDocumentsValidationContext();
  const { step, steps, onNext, resetValidationProcess } = useValidationSteps();

  const isLoanCancelled = DISABLED_STATUSES.includes(loan.status);

  return (
    <>
      {!isLoanCancelled && (
        <ActionsButtons revalidateValues={revalidateValues} resetValidationProcess={resetValidationProcess} />
      )}
      <Box display="flex" flexDirection={md ? 'row' : 'column'} gridGap={md ? 80 : 16}>
        {isLoanCancelled ? (
          <Box mt={4} width={'100%'}>
            <PendingDataWarning type={PendingDataType.CANCELLED_CARD} />
          </Box>
        ) : (
          <>
            <Box minWidth={240}>
              <DocumentationStepTracker step={step} steps={steps} />
            </Box>
            <Box flexGrow={1}>
              <CustomPaper fill="paper">
                <DocumentsValidationSteps step={step.step} onNext={onNext} />
              </CustomPaper>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};
